export default "__VITE_ASSET__BOSukeyA__"